<template>
    <div>
        <div class="row">
            <CarehomeHeader :carehome-id="carehome.id" :carehome-name="carehome.name"></CarehomeHeader>
        </div>
        <div class="row">
            <div class="col-md-6">
                <WardSelector :carehome="carehome" v-model="wardid"></WardSelector>
            </div>
            <div class="col-md-6">
                <CycleSelector :ward-id="wardid" v-model="cycleSelection" class="pull-right"></CycleSelector>
            </div>

        </div>
        <div class="row">
            <div class="col-sm-6">
                <div class="panel panel-primary">
                    <div class="panel-heading">
                        <h3 class="panel-title">
                            Patients <span class="pull-right panel-title">
                               <small> Selected : {{patientSelection.length}} </small>
                            </span>
                        </h3>
                    </div>
                    <div class="panel-body"  style="height:100%">

                        <PatientSelector
                                         :carehome-id="carehomeid"
                                         :ward-id="wardid"
                                         :patient-id="patientid"
                                         v-model="patientSelection"></PatientSelector>
                    </div>
                </div>

            </div>

            <div class="col-md-6">
                <div class="col-sm-6">
                    <div class="panel" v-bind:class="{ 'panel-primary': !IsLabelsSelected, 'panel-default': IsLabelsSelected }">
                        <div class="panel-heading">
                            <h3 class="panel-title">
                                <!--<input type="checkbox"
                                       v-model="IsLabelsSelected"
                                       v-bind:true-value="false"
                                       v-bind:false-value="true">-->
                                Charts <span class="pull-right panel-title"><small> Selected : {{chartSelection.length}} </small></span>
                            </h3>
                        </div>
                        <div class="panel-body">
                            <fieldset :disabled="IsLabelsSelected">
                                <ChartSelector v-model="chartSelection"></ChartSelector>
                            </fieldset>
                        </div>
                    </div>
                </div>
      
            </div>
        </div>

        <div class="row">
            <hr />
            <div class="form-group col-md-4" v-bind:class="{ 'has-error' : hasError}">
                <!--<a class="btn btn-primary" :disabled="hasError" @click.prevent.self="Generate">Generate</a>-->
                <WorkerButton :disabled="hasError" :submit="Generate" disable-toast="true" name="Generate"></WorkerButton>

                <a href="#" class="btn btn-warning disabled">Reset</a>
                <span class="help-block" v-if="hasError">
                    <small>{{message}}</small>
                </span>
            </div>
        </div>
    </div>

</template>


<script>
    import PatientSelector from "../../appcontrols/PatientSelector/PatientSelector.scp.html";
    import ChartSelector from "../../appcontrols/ChartSelector/ChartSelector.scp.html";
    import CycleSelector from "../../appcontrols/CycleSelector/CycleSelector.scp.html";
    import CarehomeHeader from "../../appcontrols/CarehomeHeader/CarehomeHeader.scp.html";
    import WardSelector from "../../appcontrols/WardSelector/WardSelector.scp.html";
    import WorkerButton from "../../corecontrols/workerbutton/workerbutton.scp.html";

    import Dal from './../../../scripts/dataaccess';

    export default {
        props: {
            carehomeid: {
                type: String,
                required: true
            },
            wardid: {
                type: String,
                required: false
            },
            patientid: {
                type: String,
                required: false
            }
        },
        data: function () {
            return {
                carehome: {},
                IsLabelsSelected: false,

                patientSelection: [],
                chartSelection: [],
                cycleSelection: {},

                hasError: true,
                message: ""
            }
        },
        watch: {
            patientSelection: function () { this.CheckState() },
            chartSelection: function () { this.CheckState() }
        },
        mounted: function () {

            console.log("Charts mounted with ", this.carehomeid, this.wardid, this.patientid)

            var dal = new Dal();
            if (this.carehomeid) {
                dal.GetCarehome(this.carehomeid).then(data => {
                    this.carehome = data;
                    if (!this.wardid) {
                        console.log("Ward not set", data.wards[0].id);
                        this.wardid = data.wards[0].id;
                    }
                })

            }

            this.CheckState();
        },
        methods: {
            CheckState: function () {
                this.hasError = false;
                if (this.patientSelection.length == 0) {
                    this.hasError = true;
                    this.message = "Select atleast one patient"
                    return;
                }

                if (this.chartSelection.length == 0) {
                    this.hasError = true;
                    this.message = "Select atleast one chart"
                    return;
                }
            },
            Generate: function () {

                var pids = [];
                var charts = [];

                for (var patient of this.patientSelection) {
                    pids.push(patient.pharmacyPatientId);
                }
                console.log(this.cycleSelection);
                var startDate = this.cycleSelection.startDate;
                var endDate = this.cycleSelection.endDate;

                var dal = new Dal();
                return dal.GenerateReports(pids, this.chartSelection, startDate, endDate)
            }
        },
        components: {
            PatientSelector,
            ChartSelector,
            CycleSelector,
            CarehomeHeader,
            WardSelector,
            WorkerButton
        }
    }
</script>


// WEBPACK FOOTER //
// chartprinting.scp.html?d38eb0fe